import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Address } from 'src/app/models/address.model';

@Component({
  selector: 'edit-address',
  templateUrl: './edit-address.component.html',
  styleUrls: ['./edit-address.component.less']
})
export class EditAddressComponent implements OnInit {
  addressForm!: FormGroup;
  @Output() addressSelected: EventEmitter<Address> = new EventEmitter<Address>();
  @Output() handleCloseAddress: EventEmitter<string> = new EventEmitter<string>();
  countryList:any=[{
    label:"Australia",value:"AU"
  }];
  stateList:any=[{
    label:"Aust Capital Terr",value:"AU-ACT"
  },{
    label:"New South Wales",value:"AU-NSW"
  },{
    label:"Northern Territory",value:"AU-NT"
  },{
    label:"Queensland",value:"AU-QLD"
  },{
    label:"South Australia",value:"AU-SA"
  },{
    label:"Tasmania",value:"AU-TAS"
  },{
    label:"Victoria",value:"AU-VIC"
  },{
    label:"Western Australia",value:"AU-WA"
  }]
  constructor( private fb: FormBuilder,) {
    
   }

  ngOnInit(): void {
    this.addressForm = this.fb.group({
      companyName1: ['', Validators.required],
      companyName2: [''],
      street: ['', Validators.required],
      streetNumber: [''],
      postcode: ['', Validators.required],
      city: ['', Validators.required],
      country: ['AU', Validators.required],
      state: ['', Validators.required],
      phone: ['']
    });
  }

  onSubmit() {
    
  }
  closeModal(){
    this.handleCloseAddress.emit();
  }
  saveAddress(){
    // 手动触发表单的整体校验
    this.addressForm.markAllAsTouched();
    if (this.addressForm.valid) {
      const newAddress: Address = {
        customerCode: '4000004415', 
        addressName: this.addressForm.get('companyName1')!.value, 
        streetName: this.addressForm.get('street')!.value,
        postcode: this.addressForm.get('postcode')!.value,
        city: this.addressForm.get('city')!.value,
        country: this.addressForm.get('country')!.value,
        phone: this.addressForm.get('phone')!.value,
        state: this.addressForm.get('state')!.value,
        userDefault: false, 
        isChoose: true,
        isTemporary:true
      };
      this.addressSelected.emit(newAddress);
    }
  }

}
